import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Campaign } from '../campign.model';
import { CampaignEditComponent } from '../campaign-edit/campaign-edit.component';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { CampaignType } from '../campaign-type.enum';
import { MessageDialogComponent } from '../../core/message-dialog/message-dialog.component';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { map } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { UserCompanyService } from '../../nav-menu/user-company.service';
declare var $: any;
declare var Toast: any;

@Component({
  selector: 'campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.css']
})

export class CampaignComponent implements OnInit, OnDestroy {
  private dataTable: any;
  private dtTable: any;
  private modalId: string;
  private navbarHeadline: any;
  private campaigns: Campaign[] = [];
  private selectedCompany: number;
  private subs = new SubSink();

  @ViewChild('editModal', { static: false }) editModal: CampaignEditComponent;
  @ViewChild('msgDialog', { static: false }) msgDialog: MessageDialogComponent;

  constructor(private repository: HttpRepositoryService, private titleService: Title,
    private router: Router, private antiForgery: AntiForgeryTokenService,
    private companyService: UserCompanyService) { }

  ngOnInit(): void {
    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });

    this.dataTable = $('#campaignsTable');
    this.modalId = 'campaignModalMsg';
    this.navbarHeadline = $('#navbarHeadline');
    this.navbarHeadline.html(' Campaigns');
    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpResp => {
      this.selectedCompany = cmpResp;
      this.loadData();
    });
  }

  private loadData() {
    this.subs.sink = this.repository.get<Campaign[]>('api/Campaign/List?companyId=' + this.selectedCompany).pipe(map(x => x.data)).subscribe(resp => {
      this.campaigns = resp;
      this.createDataTable();
    });
  }

  private createDataTable() {
    let that = this;

    let dtOptions = {
      data: this.campaigns,
      columns: [
        {
          name: 'id',
          visible: false
        },
        {
          name: 'subject',
        },
        {
          name: 'insAt'
        },
        {
          name: 'type'
        },
        {
          name: 'sendOn'
        },
        {
          name: 'sendUntil'
        }
      ],
      orderBy: [[0, 'asc']],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [
          {
            text: '<i class="fas fa-edit pr-3"></i> Edit',
            class: 'editrow',
            dataAttributes: ['id'],
            action: function (id) {
              that.edit(id);
            }
          },
          {
            text: '<i class="fas fa-copy pr-3"></i> Copy',
            class: 'copyrow',
            dataAttributes: ['id'],
            action: function (id) {
              that.copy(id);
            }
          },
          {
            text: '<i class="fas fa-trash pr-3"></i> Remove',
            class: 'deleterow',
            dataAttributes: ['id'],
            action: function (id) {
              that.delete(id);
            }
          },
          {
            text: '<i class="fas fa-chart-line"></i> Statistic',
            class: 'statisticrow',
            dataAttributes: ['id'],
            action: function (id) {
              that.router.navigate(["/campaign/statistic"], { state: { data: { id: id } } });
            }
          }]
      },
      buttons: [{
        text: '<i class="fas fa-plus"></i>',
        class: '',
        action: function () {
          if (that.selectedCompany == 0) {
            that.msgDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, "Import contact.");
          } else {
            that.create()
          }
        }
      },
      {
        text: '<i class="fas fa-trash-alt"></i>',
        class: '',
        action: function () {
          that.deleteList()
        }
      }]
    }

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }

    this.dtTable = this.dataTable.LinkTable(dtOptions);
  }

  private onSaved(data: Campaign) {
    let campaign = this.campaigns.find(x => x.id == data.id);

    if (campaign) {
      campaign.subject = data.subject;
      campaign.insAt = this.formatDate(data.insAt);
      campaign.type = data.type;
      campaign.sendOn = this.formatDate(data.sendOn);
      campaign.sendUntil = this.formatDate(data.sendUntil);
    } else {
      let newCampaign = new Campaign(data.id, data.subject, data.type, null, null, null, null, null, null, null, this.formatDate(data.insAt), null, this.formatDate(data.sendOn), this.formatDate(data.sendUntil));
      this.campaigns.push(newCampaign);
    }

    this.createDataTable();
  }

  private formatDate(data: string): string {
    if (data) {
      let dateTimeArr = data.split(' ');
      let date = dateTimeArr[0];
      let dateArr = date.split('-');

      let time = '';
      if (dateTimeArr.length > 1) {
        time = dateTimeArr[1];
        time = time.substring(0, time.lastIndexOf(':'));
      }

      return dateArr[2] + '.' + dateArr[1] + '.' + dateArr[0] + ' ' + time;
    }
  }

  private create() {
    this.editModal.show(new Campaign(), true, 0, this.selectedCompany);
  }

  private edit(id) {
    this.subs.sink = this.repository.get<Campaign>('api/Campaign/Details/' + id + '?companyId=' + this.selectedCompany).pipe(map(x => x)).subscribe(resp => {
      if (resp.statusCode == 200) {
        let campaign = resp.data;
        let key = resp.data.type;
        
        this.editModal.show(campaign, false, CampaignType[key], this.selectedCompany);
      } else {
        Toast.Show(resp.error, 'Campaign error', 'error');
      }
    });
  }

  private copy(id) {
    this.subs.sink = this.repository.get<Campaign>('api/Campaign/Details/' + id + '?campaignId=' + this.selectedCompany).pipe(map(x => x)).subscribe(resp => {
      if (resp.statusCode == 200) {
        let campaign = resp.data;
        let key = resp.data.type;
        campaign.id = 0;

        this.editModal.show(campaign, true, CampaignType[key], this.selectedCompany);
      } else {
        Toast.Show(resp.error, 'Campaign error', 'error');
      }
    });
  }

  private delete(id) {
    let campaign = this.campaigns.find(x => x.id == id);

    if (campaign) {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Delete campaign error', 'error');
        } else {
          this.msgDialog.show("Are you sure you want to delete " + campaign.subject + "?", MessageType.YESNO, 'Delete conformation!', () => {
            this.subs.sink = this.repository.del('api/Campaign/Remove/' + id, afResp.data).subscribe(resp => {
              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Delete campaign error', 'error');
              } else {
                Toast.Show('Campaign successfully deleted.', 'Delete campaign', 'success');
                this.loadData();
              }
            });
          });
        }
      });
    }
  }

  private deleteList() {
    let checked: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => x.id);

    if (checked.length == 0) {
      this.msgDialog.show("You must select campaign!", MessageType.OK, "Delete conformation");
    } else {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Delete campaign error', 'error');
        } else {
          this.msgDialog.show("Are you sure you want do delete " + checked.length + " campaign(s)?", MessageType.YESNO, "Delete conformation", () => {
            this.subs.sink = this.repository.post<number[]>('api/Campaign/ListRemove', checked, afResp.data).subscribe(resp => {
              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Delete campaign error', 'error');
              } else {
                Toast.Show('Campaigns successfully deleted.', 'Delete campaigns', 'success');
                this.loadData();
              }
            });
          });
        }
      })
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
